import apiClient from './client';

export interface CreateUserData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: string;
  phone?: string;
  dateOfBirth?: string;
}

export interface UpdateUserData {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  dateOfBirth?: string;
  isActive?: boolean;
}

export interface UpdateProfileData {
  avatar?: string;
  bio?: string;
  btn?: string;
  emergencyContact?: string;
  emergencyPhone?: string;
  address?: string;
  city?: string;
  country?: string;
  postalCode?: string;
  inactivityTimeout?: number;
}

export const getUsers = (params?: { page?: number; limit?: number; role?: string; search?: string }) => {
  return apiClient.get('/users', { params });
};

export const userApi = {
  getUsers: (page: number = 1, limit: number = 20, role?: string, search?: string) => {
    return apiClient.get('/users', {
      params: { page, limit, role, search },
    });
  },

  getUserById: (id: string) => {
    return apiClient.get(`/users/${id}`);
  },

  createUser: (data: CreateUserData) => {
    return apiClient.post('/users', data);
  },

  updateUser: (id: string, data: UpdateUserData) => {
    return apiClient.put(`/users/${id}`, data);
  },

  deleteUser: (id: string) => {
    return apiClient.delete(`/users/${id}`);
  },

  getUserStats: () => {
    return apiClient.get('/users/stats');
  },

  getProfile: () => {
    return apiClient.get('/profile');
  },

  updateProfile: (data: UpdateProfileData) => {
    return apiClient.put('/profile', data);
  },

  changePassword: (currentPassword: string, newPassword: string) => {
    return apiClient.post('/profile/change-password', {
      currentPassword,
      newPassword,
    });
  },
};
